import React from 'react';

import { useLoadChart } from 'scenes/FinancialResults/data';

import { FinancialResultChart } from './FinancialResultChart';

export default ({ id }) => {
  const { data: chartSeries = [], isLoading } = useLoadChart(id);

  return (
    <FinancialResultChart
      id={id}
      chartSeries={chartSeries}
      loading={isLoading}
    />
  );
};
